/**
 * Date formatting utilities for admin-web
 */

export interface FormatDateOptions {
  /** Include weekday (e.g., "Mon") */
  includeWeekday?: boolean;
}

/**
 * Format a timestamp to a human-readable date string
 * 
 * @param timestamp - Unix timestamp in milliseconds
 * @param options - Formatting options
 * @returns Formatted date string (e.g., "Jan 15, 2026, 10:30 AM" or "Mon, Jan 15, 2026, 10:30 AM")
 * 
 * @example
 * ```ts
 * formatDate(Date.now()); // "Jan 15, 2026, 10:30 AM"
 * formatDate(Date.now(), { includeWeekday: true }); // "Mon, Jan 15, 2026, 10:30 AM"
 * ```
 */
/**
 * Format a timestamp as a date without the time, e.g. "Jan 15, 2026".
 */
export function formatDay(timestamp: number): string {
  return new Date(timestamp).toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
  });
}

export function formatDate(timestamp: number, options: FormatDateOptions = {}): string {
  const { includeWeekday = false } = options;
  
  return new Date(timestamp).toLocaleDateString('en-US', {
    ...(includeWeekday && { weekday: 'short' }),
    month: 'short',
    day: 'numeric',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
}
